<template>
  <div>
    <input
      v-if="field.canEdit"
      type="file"
      @change="onFileChanged"
    />
    <a
      v-if="privateFile && field.canRead"
      :href="privateFile[field.fieldName + '_link']"
      target="_blank"
    >
      {{ privateFile[field.fieldName] }}
    </a>
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormPrivateFile',

  props: {
    ...formElementProps
  },

  data: () => {
    return {
      privateFile: null,
      uploadedFile: null
    }
  },

  computed: {
    ...sharedComputed
  },

  created () {
    this.privateFile = this.value
  },

  methods: {
    ...sharedMethods,

    onFileChanged (event) {
      let file = event.target.files[0]
      const extension = file.name.split('.').pop()

      if (extension) {
        const reader = new FileReader()
        reader.onload = e => {
          this.value[this.field.fieldName] = e.target.result
          this.value[this.field.fieldName + 'Name'] = file.name
          this.value[this.field.fieldName + 'Extention'] = extension
          this.uploadedFile = e.target.result
        }
        reader.readAsBinaryString(file)
      }
    }
  }
}
</script>
